import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EfCardsB from '@elem/ui/ef-cards-b';
import EfSection from '@elem/ui/ef-section';
import EfShopCardA from '@elem/ui/ef-shop-card-a';
import EfSpec from '@elem/ui/ef-spec';
import { Fragment } from 'react';
import EmailCom from '../../common/EmailCom';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale);

    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724125353740/sectionB_card_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139155119/sectionB_card_1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724125353566/sectionB_card_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139155309/sectionB_card_2_h5.jpg',

            desc: t('section_B_card2_title'),
            title: t('section_B_card2_desc'),
            vertical: 'descTop',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724125354288/sectionB_card_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139155717/sectionB_card_3_h5.jpg',

            desc: t('section_B_card3_title'),
            title: t('section_B_card3_desc'),
            vertical: 'descTop',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724652004477/sectionB_card_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724652018649/sectionB_card_4_h5.jpg',

            desc: t('section_B_card4_desc'),
            title: t('section_B_card4_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724125354084/sectionB_card_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139155515/sectionB_card_5_h5.jpg',

            title: t('section_B_card5_desc'),
            desc: t('section_B_card5_title'),
            vertical: 'descTop',
        },
    ];
    const itemsB = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724125731706/sectionB_product_1.png',
            label: t('section_B_product1_label'),
            title: t('section_B_product1_title'),
            desc: t('section_B_product1_desc'),
            desc2: t('section_B_product1_desc2'),
            moreLink: `https://www.ecoflow.com/${locale}/river-3-series-portable-power-station`,
            moreText: t('section_product_btn_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724125731841/sectionB_product_2.png',
            label: t('section_B_product2_label'),
            title: t('section_B_product2_title'),
            desc: t('section_B_product2_desc'),
            desc2: t('section_B_product2_desc2'),
            moreLink: `https://www.ecoflow.com/${locale}/river-3-series-portable-power-station`,
            moreText: t('section_product_btn_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724651673635/sectionB_product_3.png',
            label: t('section_B_product3_label'),
            title: t('section_B_product3_title'),
            desc: t('section_B_product3_desc'),
            desc2: t('section_B_product3_desc2'),
            moreLink: `https://www.ecoflow.com/${locale}/river-3-series-portable-power-station`,
            moreText: t('section_product_btn_text'),
        },
    ];

    const OffTips = () => {
        return (
            <span className="SectionA-off-tips">
                {t('section_B_off_value')} <span className="SectionA-off-tips-text">{t('section_off')}</span>
            </span>
        );
    };
    return (
        <div className={styles.TheComp} id="ID-SectionB">
            <EfSpec />
            <EfSection title={t('section_B_title')} desc={t('section_B_desc')} />
            <EfCardsB items={itemsA} />
            <EmailCom
                offTipsL={IS_NA_SITES ? 'Stay tuned for early release notifications and time-limited discounts' : t('section_early_bird_title')}
                offTips={IS_NA_SITES ? null : <OffTips />}
                offTipsR={IS_NA_SITES ? '' : t('section_and')}
                freeTips={IS_NA_SITES ? '' : t('section_free')}
                freeTipsR={IS_NA_SITES ? '' : t('section_bag_2')}
                productValue={[2]}
                gtm_event_name="river3_submit"
                subscribeData={{
                    sector_name: t('section_B_title'),
                    entry_position: 5,
                }}
            />
            <div className="ef-container SectionA-list">
                {itemsB.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfShopCardA {...item} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
}
